import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer class="footer footer-bg pt-7 pb-3">
        <div class="container">
          <div class="row gy-6 gy-xl-0 pb-2">
            <div class="col-xl-5 col-lg-12 col-md-6 col-12">
              <div class="d-flex flex-column gap-4 pe-5">
                <h1 className="display-6 fw-bold ls-sm lh-1 mb-0">
                  <span className="text-white fw-light">
                    Albedo Institute, Ranchi
                  </span>
                </h1>
                <p class="mb-0 lh-sm text-white">
                  Albedo Institute, a part of Albinstitute Pvt. Ltd, is a
                  premier educational institution based in Ranchi, Jharkhand. We
                  are committed to making learning meaningful, engaging, and
                  accessible while guiding students through key academic
                  milestones with confidence and clarity.
                  <br />
                  <br />
                  At Albedo Institute, we believe education goes far beyond
                  textbooks and examinations. True learning is a journey of
                  self-exploration, intellectual growth, and personal
                  development.
                  <br />
                  Our teaching philosophy is rooted in:
                  <br />
                  <br />
                  <ul>
                    <li>Deep conceptual clarity</li>
                    <li>Curiosity-driven learning</li>
                    <li>Confidence building</li>
                    <li>Continuous academic and personal improvement</li>
                  </ul>
                </p>
              </div>
            </div>
            <div class="col-xl-2 col-md-3 col-12">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fw-medium text-light">
                  Useful Pages
                </span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <a href="#!" class="nav-link">
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      About Us
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      About Founder
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Our Faculty
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Career in Albedo
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Our Courses
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Admission
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Seminars & Events
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Image Gallery
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Video Gallery
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-2 col-md-3 col-6">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fw-medium text-light">
                  Community
                </span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <a href="#!" class="nav-link">
                      Enquiry Now
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Blogs & Articles
                    </a>
                  </li>
                  <li>
                    <Link to="/terms" class="nav-link">
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy" class="nav-link">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Help and Support
                    </a>
                  </li>
                  <li>
                    <a href="#!" class="nav-link">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-12">
              <div class="d-flex flex-column gap-5">
                <div class="d-flex flex-column gap-3">
                  <span class="text-white-stable fw-medium text-light">
                    Contact SLN
                  </span>
                  <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                    <li className="mb-1">
                      Toll free: <span class="fw-normal">+91 76772 45574</span>
                    </li>
                    <li className="mb-1">
                      Email:{" "}
                      <span class="fw-normal">albedoinfo1@gmail.com</span>
                    </li>
                    <li className="lh-sm mb-1">
                      Address:{" "}
                      <span class="fw-normal">
                        3rd Floor, Karni Heights, Club Road, near Gossner
                        College, Ranchi, Jharkhand - 834001.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-5 pb-2">
          <h4 className="text-white lh-sm mb-0 fw-normal">
            Our Approach to Learning
          </h4>
          <p className="text-white mb-2">
            Albedo Institute follows a student-centered approach that adapts to
            different learning styles and academic goals. Our methodology
            focuses on:
          </p>
          <p class="mb-0 lh-sm text-white">
            <ul className="text-white lh-md">
              <li>Strong academic foundations</li>
              <li>Concept-based teaching over rote learning</li>
              <li>Regular assessments and constructive feedback</li>
              <li>Mentorship that builds discipline and confidence</li>
            </ul>
          </p>
        </div>

        <div class="border-top border-light">
          <div className="container pt-3">
            <div class="row">
              <div class="col-lg-6 col-12 text-center text-md-start">
                <span className="fw-normal m-0 text-light lh-sm">
                  © 2025 Albedo Institute, Ranchi
                </span>
              </div>
              <div class="col-12 col-lg-6 d-lg-block d-none">
                <nav class="nav nav-footer justify-content-center justify-content-md-start justify-content-lg-end">
                  <Link to="/terms" class="nav-link active text-light">
                    Terms of Use
                  </Link>
                  <a class="nav-link text-light" href="#!">
                    Cookies Settings
                  </a>
                  <Link to="/privacy" class="nav-link text-light">
                    Privacy Policy
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
